import React, { useState } from 'react'
import useSurveyLocale from '../../modules/locale/useSurveyLocale'
import { Checkbox } from 'primereact/checkbox'
import { hapticEffects } from '../../lib/hapticEffects'

import style from './style.module.scss'
import commonStyle from '../_common/style.module.scss'

import CnPrequalIcons from '../_common/images/cn-prequal.svg'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'
import { ConversationResponse } from './types'

type PrequalViewPropTypes = {
  showValidation: boolean
  onUpdateResponse: (response: ConversationResponse) => void
}

const PrequalView = ({ showValidation, onUpdateResponse }: PrequalViewPropTypes) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()
  const { localeOptions } = useInterfaceLocale()
  const [selects, setSelects] = useState(Array.from({ length: 4 }).fill(null))

  const onSelectedChange = (answerIndex: number) => {
    if (selects[3] && answerIndex != 3) return

    const selected = !selects[answerIndex]
    if (selected) {
      hapticEffects.selection()
    }
    selects[answerIndex] = selected
    setSelects([...selects])
    onUpdateResponse({ approve: Boolean(selects[0] && selects[1] && selects[2] && !selects[3]) })
  }

  const renderIndicator = (id: number) => {
    const mark = selects[3] ? 'no' : selects[id] ? 'yes' : false == selects[id] ? 'no' : ''

    return (
      <div className={style.indicatorItem} key={id} data-testid="SW-VR-PRE-Indicator">
        <i
          className={`${'yes' === mark ? 'icon-aytmfd-checkmark' : 'icon-aytmfd-delete'}
        ${'no' === mark ? 'warning' : ''}`}
        />
      </div>
    )
  }

  return (
    <fieldset
      className={`${style.cnPrequalView} ${localeOptions.rtl ? style.videoResponsePrequalViewRTL : ''} ${
        viewport.mobile ? style.mobile : ''
      }`}
      data-testid="SW-VR-PRE"
    >
      <div className={style.panel} data-testid="SW-VR-PRE-Panel">
        <div className={style.indicatorRow}>{[0, 1, 2].map(indicatorId => renderIndicator(indicatorId))}</div>
        <img role="presentation" data-testid="SW-VR-PRE-Icons" className={style.icons} src={CnPrequalIcons} alt="" />
      </div>

      <legend
        className={`${commonStyle.validationMessage} ${showValidation ? commonStyle.error : ''}`}
        data-testid="SW-VR-PRE-ValidationMessage"
        dangerouslySetInnerHTML={{ __html: t<(n1: number, n2: number) => string>('questions', 'cb', 'note')(0, 5000) }}
      />

      {selects.map((answer, answerIndex) => {
        const selected = answer && ((!selects[3] && answerIndex < 3) || 3 == answerIndex)
        return (
          <div className={style.answerFrame} key={answerIndex} data-testid="SW-VR-PRE-Answer">
            <label className={style.answerRow} aria-label={t('questions', 'vr_pre', 'answers', answerIndex.toString())}>
              <Checkbox
                inputId={answerIndex.toString()}
                value={answerIndex}
                name="answer"
                disabled={selects[3] && answerIndex < 3}
                checked={selected}
                onChange={() => onSelectedChange(answerIndex)}
              />
              <span
                data-testid="SW-VR-PRE-AnswerText"
                className={style.answerText}
                dangerouslySetInnerHTML={{ __html: t('questions', 'cn', 'answers', answerIndex.toString()) }}
              ></span>
            </label>
          </div>
        )
      })}
    </fieldset>
  )
}

export default PrequalView
